import React from "react";
import {Link} from "gatsby";

export default function BannerWithText() {

    return (
        <section className="p-0">
            <div className="container-fluid pe-45px ps-45px">
                <div className="row g-0">
                    <div
                        className="col-12 skrollr-parallax mx-auto p-8 position-relative"
                        data-bottom-top="width: 100%"
                        data-center-top="width: 100%;"
                        data-parallax-background-ratio="0.5"
                        style={{
                            backgroundImage: "url(../../images/hire-banner.jpg)"
                        }}
                        data-anime='{ "el": "childs", "translateY": [15, 0], "translateX": [15, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'
                    >
                        <div className="bg-white box-shadow-quadruple-large position-relative border-radius-4px w-450px xs-w-100 overflow-hidden z-index-1 float-end">
                            <div className="p-50px lg-p-30px last-paragraph-no-margin text-center">
                                <img
                                    src="../../images/agency-expertise-pen.png"
                                    className="w-85px mb-30px"
                                    alt="matrixbrains pvt ltd expertise banne pen"
                                    loading="lazy"
                                />
                                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px d-block">
                                  Stuck on Software Development? We Bridge the Gap Between Idea and Reality.
                                </span>
                                <p className="w-95 lg-w-100">
                                    Tired of endless research and technical hurdles? Let us navigate the app
                                    development journey for you. We'll handle the complex, you focus on the amazing.
                                </p>
                            </div>
                            <div className="bg-dark-gray p-15px xs-p-10px text-center">
                                <Link
                                    to="/contact"
                                    className="fs-14 xs-fs-12 ls-minus-05px text-white text-white-hover text-uppercase fw-500"
                                >
                                    <i className="feather icon-feather-mail fs-20 me-10px align-middle" />
                                    Talk with our expert team
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}